const groupBooksByGrade = (data) =>
  data.reduce((acc, item) => {
    const { grade } = item

    if (!acc[grade]) {
      acc[grade] = []
    }

    acc[grade].push(item)
    return acc
  }, {})

export default groupBooksByGrade
